import React, { ForwardedRef, useEffect, useRef, useState } from 'react';
import { Button, IButtonProps } from './Button';
import { Spinner } from '../loading';
import * as classes from './Button.module.scss';
import clsx from 'clsx';

export interface IBusyButtonProps extends IButtonProps {
    busy?: boolean;
    /**
     * The time after which a spinner will be displayed
     */
    timeout?: number;
}

export const BusyButton = React.forwardRef((props: IBusyButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
    const { busy = false, timeout = 250, children, ...buttonProps } = props;

    const [ isBusy, setIsBusy ] = useState(false);
    const to = useRef<number>();

    useEffect(() => {
        if (!busy) {
            setIsBusy(false);
        } else {
            to.current = window.setTimeout(() => {
                setIsBusy(true);
            }, timeout);
        }
        return () => {
            if (to.current) {
                window.clearTimeout(to.current);
            }
        };
    }, [ busy, timeout ]);

    return (
        <Button
            {...buttonProps}
        >
            <span className={clsx(classes.busyContainer, isBusy && classes.busyContainerActive)}>
                {isBusy && <span className={classes.busySpinner}><Spinner/></span>}
                <span className={classes.busyContent}>
                    {children}
                </span>
            </span>
        </Button>
    );
});
